import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { GoogleSigninButtonModule, SocialAuthService, SocialLoginModule, SocialUser } from '@abacritt/angularx-social-login';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterOutlet, NzIconModule, NzLayoutModule, NzMenuModule, NzBreadCrumbModule, SocialLoginModule, GoogleSigninButtonModule, NzSpaceModule, NzAvatarModule, NzDropDownModule, NzButtonModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  isCollapsed = false;
  api_docs = environment.yomaApiURL + '/docs/';
  user: SocialUser | undefined;
  authService = inject(SocialAuthService)
  cdr = inject(ChangeDetectorRef)
  router = inject(Router)

  ngOnInit():void {
    this.authService.authState.subscribe((user) => {
      this.user = user
      this.cdr.detectChanges()
    })
  }

  isGroupActive(paths: string[]): boolean {
    return paths.some(path => this.router.url.startsWith(path))
  }

  logout() {
    this.authService.signOut()
  }
}
